import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { Observable } from 'rxjs';

@Injectable()
export class IRPLookupService extends BaseApiService {

    public getLookup(lookup: string) {
        return this.get(`irp/configuration/${lookup}`);
    }

    public getLookupTypes() {
        return this.get('irp/configuration/irpLookups');
    }

    public getFleetLookupTypes() {
        return this.get('irp/configuration/fleet');
    }

    public getIRPJurisdictions(): Observable<any> {
        return this.get('IRP/configuration/Jurisdictions');
    }

    public getIFTAJurisdictions(): Observable<any> {
        return this.get('IRP/configuration/IFTAJurisdictions');
    }

    public getIFTASplitJurisdictions(): Observable<any> {
        return this.get('IRP/configuration/IFTASplitJurisdictions');
    }

    public getCorrespondenceLookupTypes() {
        return this.get('irp/configuration/correspondence');
    }

    public getBodyStyleTypesMap(): Observable<any> {
        return this.get('irp/configuration/bodystyletypesmap');
    }

    public getMotorCarrierBodyStyleTypes(): Observable<any> {
        return this.get('irp/configuration/bodystyletypes');
    }

    public getMotorCarrierBodyStyleTypeVehicleBodyStyleTypeMap(bodyStyleTypeId: number): Observable<any> {
        return this.get(`irp/configuration/bodystyletypesmap/${bodyStyleTypeId}`);
    }

    public getMotorCarrierJurisdictionConfiguration(): Observable<any> {
        return this.get('irp/configuration/jurisdictions/motorcarrier/configuration');
    }
}
